import React, { useState } from 'react';
import classes from './style.module.css'
import Aux from 'react-aux'
import { Col, Button } from 'react-bootstrap';

import ProfileMenu from "../UI/ProfileMenu"
import ExportData from "../ExportData"
import { SET_SELECTION_STATE, SET_SOCCER_LEAGUES_STATE, SET_SOCCER_MATCHES_STATE } from "../../redux/actions"
import { connect } from "react-redux"
import { HEADER_CONTROLS, TICKLER_TAB_BUTTON } from "../../constants/Constants"
import { passDateToString } from '../../util/date/date-utils'
import { currentDateStr } from '../../util/date/date-utils'
import DatePicker from '../../components/UI/DatePicker'
import bookIcon from "../../assets/images/book.png"
import RaceSlidingPane from '../RaceSlidingPane';
import "react-sliding-pane/dist/react-sliding-pane.css";
import Clock from 'react-live-clock';

const Header = props => {
    const [selectionDate, setSelectionDate] = useState(currentDateStr())


    const selectionDateChangeHandler = (event) => {
        const newDate = passDateToString(event);
        const selectionState = { ...props.selectionState };
        selectionState.selectionDate = newDate;
        props.setSelectionState(selectionState);
        setSelectionDate(newDate)
    }

    return (
        <Aux>
            <Col className={classes.HeaderLeft} xs={8}>
                <ExportData label={HEADER_CONTROLS.EXPORT_DATA_BUTTON.label} mode={props.selectionState.mode}
                    selectionDate={props.selectionState.selectionDate}
                    currentTab={props.selectionState.tab}
                    home={props.selectionState.home}
                    away={props.selectionState.away} />
                <a href="https://winningmore.com/manual.htm" target="_blank"><img style={{ width: "29px", height: "34px", marginTop: "10px", marginLeft: "50px" }} src={bookIcon} /></a>
                <font style={{ marginLeft:'50px', marginTop:'13px', color:'#FFFFFF', fontSize: '1.2em' }} >
                     AET Time : <Clock format={'(HH:mm:ss), DD/MM/YYYY'} ticking={true} timezone={'Australia/Sydney'} />
                </font>
            </Col>
            <Col className={classes.HeaderRight} xs={4}>
                <DatePicker selectedDate={selectionDate} selectedDateChanged={selectionDateChangeHandler} />
                <ProfileMenu logoutClicked={props.logoutClicked} />
            </Col>
        </Aux>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        selectionState: state.selectionState,
        ...ownProps
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload }),
        setSoccerMatchesState: payload =>
            dispatch({ type: SET_SOCCER_MATCHES_STATE, payload: payload }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);